import { render, staticRenderFns } from "./PreCustomerForm.vue?vue&type=template&id=dfb169ae&"
import script from "./PreCustomerForm.vue?vue&type=script&lang=js&"
export * from "./PreCustomerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb169ae')) {
      api.createRecord('dfb169ae', component.options)
    } else {
      api.reload('dfb169ae', component.options)
    }
    module.hot.accept("./PreCustomerForm.vue?vue&type=template&id=dfb169ae&", function () {
      api.rerender('dfb169ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prevent/CustomerMgt/modules/PreCustomerForm.vue"
export default component.exports